import { encodedStringParser, numberArrayParser, numberParser, stringParser } from '../inboundParsers';
export const HAND_RANK_PAYLOAD_DEFINITION = {
    shouldSplitWithBraces: true,
    definitionParts: [
        { name: 'handValueWithoutKickers', parser: numberParser },
        { name: 'name', parser: encodedStringParser },
        { name: 'subName', parser: encodedStringParser },
        { name: 'nicknamesString', parser: stringParser },
        { name: 'cardIndexes', parser: numberArrayParser }
    ]
};
